export enum Scale {
    Percent125 = 1.25,
    Percent100 = 1,
    Percent50 = 0.5,
    Percent30 = 0.3,
    Percent25 = 0.25,
    Percent20 = 0.2,
    Percent10 = 0.1,
}
